import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel, Grid, Typography, Box, TextField, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    root: {},
    item: {
        display: 'flex',
        flexDirection: 'column'
    },
    input: {
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input': {
            color: '#263238'
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#263238'
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            outline: 'none',
            borderWidth: 1,
            borderColor: '#263238'
        }
    }
});

function FmsCan(props) {
    const classes = useStyles();

    return (
        <Grid classes={classes.item} item md={4} sm={6} xs={12}>
            <Typography color="textPrimary" gutterBottom variant="h6">
                FMS CAN service
            </Typography>
            {props.loading ? (
                <CircularProgress />
            ) : (
                <>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={props.values.fmsCanEnable}
                                onChange={() => props.setFieldValue('fmsCanEnable', !props.values.fmsCanEnable)}
                            />
                        }
                        label="Enable"
                    />
                    <Box mt={2}>
                        <TextField
                            disabled={!props.values.fmsCanEnable}
                            label="CAN interface"
                            name="interface"
                            type="text"
                            value={props.values.fmsCanInterface}
                            variant="outlined"
                            size="small"
                            classes={classes.input}
                            InputProps={{
                                readOnly: true
                            }}
                        />
                    </Box>
                </>
            )}
        </Grid>
    );
}

FmsCan.propTypes = {
    values: PropTypes.object,
    setFieldValue: PropTypes.func,
    loading: PropTypes.bool
};

export default FmsCan;
